import { Box, CircularProgress, Grid, Typography, useTheme } from '@mui/material';
import { FC, MouseEvent, RefObject, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import strings from '../../../common/Translation/Translate';
import PrimaryButton from '../../../components/Button/PrimaryButton';
import Form, { FormDataModel } from '../../../components/Form';
import { setNotificationMessage } from '../../../utils/redux/reducer/Notification-details-slice';
import { removeErrorFieldsFromValues } from '../../../utils/validators';
import { GuestUserForm } from './GuestUserForm';
import { routes } from 'utils/constants/routes';
import { setAuthentication } from 'utils/redux';
import { setGuestUser } from 'utils/redux/reducer/authentication-slice';

const GuestUser: FC<any> = ({ handleClose }: { handleClose: any; setDrawerState: any; setMessage: any }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  let signUpForm: RefObject<Form | null | undefined> = useRef();
  const [hasError, setHasError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const handleSignUp = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const signupFormData = signUpForm.current as {
      getFormData: () => { formData: FormDataModel; isFormValid: boolean };
    };
    const signUpFormData = signupFormData.getFormData();
    const formData1 = signUpFormData.formData;
    const isFormValid1 = signUpFormData.isFormValid;
    const bodyData1 = removeErrorFieldsFromValues(formData1);

    const body = {
      firstName: bodyData1.firstName,
      lastName: bodyData1.lastName,
      phone: bodyData1.phone,
      companyName: '',
      designation: '',
      company: false,
      email: bodyData1.email,
      gst: '',
    };
    try {
      setHasError(false);
      if (isFormValid1) {
        dispatch(setAuthentication({ access_token: 'guest_token', refresh_token: 'guest_refresh_token' }));
        dispatch(setGuestUser(body));
        handleClose();
        navigate(routes.payment_summary);
      } else {
        setHasError(true);
      }
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        dispatch(
          setNotificationMessage({
            display: true,
            severity: 'error',
            message: error.response.data.message,
          }),
        );
      }
    }
  };

  return (
    <>
      <Box bgcolor={theme.palette.secondary.light}>
        <Grid container py={2} px={5} alignItems={'center'} justifyContent={'space-between'}>
          <Grid item>
            <Typography className="font-cinzel" fontWeight={'bold'} color={'primary'} fontSize={'20px'}>
              {strings.guestUserText}
            </Typography>
          </Grid>
        </Grid>
        <Grid container mt={1} px={4} bgcolor={theme.palette.secondary.light} spacing={1} flexDirection={'column'}>
          <Grid item>
            <Grid container columnSpacing={2} rowSpacing={1}>
              <Form
                hasError={hasError}
                ref={signUpForm as RefObject<Form>}
                model={GuestUserForm(strings)}
                values={{}}
              />
            </Grid>
          </Grid>
          <Grid item xs={5.2} mb={2}>
            <PrimaryButton disabled={loading} sx={{ mt: 1, py: 1 }} onClick={handleSignUp} type="submit">
              {loading && <CircularProgress sx={{ mr: 1 }} size={20} />}
              {strings.guestUserText}
            </PrimaryButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default GuestUser;
